/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IHospitalInstitution } from 'app/shared/model/hospital-institution.model';

export interface IPaymentCommunity {
  id?: string;
  name?: string | null;
  description?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  hospital?: IHospital;
  institution?: IHospitalInstitution | null;
}

export const defaultValue: Readonly<IPaymentCommunity> = {
  active: false,
};
